import AsientosMesa from "./AsientosMesa";
import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import ItemMesaDividida from "./ItemMesaDividida";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { BrowserView, MobileView } from "react-device-detect";

const MySwal = withReactContent(Swal);

const Mesa = ({
  mesa,
  eliminarMesa,
  esReserva,
  onClick,
  listaAsientos,
  selected,
  listaAsientosRegistrados,
  maxAsientos,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [asientosOcupados, setAsientosOcupados] = useState(0);
  const [asientosOcupadosCDA, setAsientosOcupadosCDA] = useState(0);

  const [color, setColor] = useState("N");

  const handleOpenDialog = () => {};
  const handleClick = (asiento) => {
    onClick(asiento);
  };
  const handleCloseDialog = () => {
    setIsOpen(false);
  };
  const handleDragStart = (e) => {
    e.dataTransfer.setData("mesaId", mesa.id);
  };

  const handleEliminarMesa = () => {
    if (esReserva) {
      if (!isOpen) setIsOpen(true);
    } else {
      MySwal.fire({
        title: "¿Eliminar mesa? ",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Eliminar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          eliminarMesa(mesa.id);
        }
      });
    }
  };
  useEffect(() => {
    if (listaAsientosRegistrados) {
      let asientospormesa = 0;
      let asientospormesaCDA = 0;

      //console.log(listaAsientosRegistrados);
      for (let i = 0; i < mesa.aLibres; i++) {
        if (
          listaAsientosRegistrados.includes(
            mesa.id + `${String.fromCharCode(65 + i)}`
          )
        ) {
          asientospormesa++;
        }
        if (
          listaAsientos.includes(mesa.id + `${String.fromCharCode(65 + i)}`)
        ) {
          asientospormesaCDA++;
        }
      }
      setAsientosOcupados(asientospormesa);
      setAsientosOcupadosCDA(asientospormesaCDA);
    }
    //console.log("Asientos ocupados " + listaAsientos);
  }, [listaAsientosRegistrados]);

  useEffect(() => {
    if (asientosOcupados > 0) {
      setColor("N");
    }
    if (asientosOcupados == 0) {
      setColor("V");
    }
    if (asientosOcupados == mesa.aLibres) {
      setColor("R");
    }
  }, [asientosOcupados]);
  return (
    <div>
      <BrowserView>
        <div
          onClick={handleEliminarMesa}
          className={
            asientosOcupados == mesa.aLibres
              ? "mesa-llena"
              : asientosOcupados > 0
              ? "mesa-medio"
              : asientosOcupadosCDA >= 1
              ? "mesa-CDA"
              : "mesa"
          }
          style={{ top: mesa.y, left: mesa.x }}
          draggable
          onDragStart={handleDragStart}
        >
          <div>
            <div style={{ position: "relative", textAlign: "center" }}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <p style={{ color: "black", fontSize: "18px" }}>
                  <span>
                    {mesa.id} <br></br>
                  </span>
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {asientosOcupados == mesa.aLibres
                      ? null
                      : asientosOcupados > 0
                      ? `${asientosOcupados}/${mesa.aLibres} `
                      : null}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <Dialog open={isOpen} onClose={handleCloseDialog}>
          <DialogContent>
            <ItemMesaDividida
              divisions={mesa.aLibres}
              onClick={handleClick}
              mesaID={mesa.id}
              listaAsientos={listaAsientos}
              selected={selected}
              listaAsientosRegistrados={listaAsientosRegistrados}
              maxAsientos={maxAsientos}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Aceptar</Button>
          </DialogActions>
        </Dialog>
      </BrowserView>

      <MobileView>
        <div
          onClick={handleEliminarMesa}
          className={
            asientosOcupados == mesa.aLibres
              ? "mesa-llena"
              : asientosOcupados > 0
              ? "mesa-medio"
              : "mesa"
          }
          style={{ top: mesa.y * 0.33, left: mesa.x * 0.33 }}
          draggable
          onDragStart={handleDragStart}
        >
          <div>
            <div style={{ position: "relative", textAlign: "center" }}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <p style={{ color: "black", fontSize: "6px" }}>
                  <span>
                    {mesa.id} <br></br>
                  </span>
                  <span style={{ color: "red", fontSize: "5px" }}>
                    {asientosOcupados == mesa.aLibres
                      ? null
                      : asientosOcupados > 0
                      ? `${asientosOcupados}/${mesa.aLibres} `
                      : null}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <Dialog open={isOpen} onClose={handleCloseDialog}>
            <DialogContent>
              <ItemMesaDividida
                divisions={mesa.aLibres}
                onClick={handleClick}
                mesaID={mesa.id}
                listaAsientos={listaAsientos}
                selected={selected}
                listaAsientosRegistrados={listaAsientosRegistrados}
                maxAsientos={maxAsientos}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog}>Aceptar</Button>
            </DialogActions>
          </Dialog>
        </div>
      </MobileView>
    </div>
  );
};

export default Mesa;
